
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 34 34","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M25.36 17c0 .469-.183.86-.547 1.172-.313.312-.704.469-1.172.469H7L.36 25.359V2c0-.469.156-.86.468-1.172C1.141.516 1.531.36 2 .36h21.64c.47 0 .86.157 1.172.47.365.312.547.702.547 1.171v15zM32 7c.469 0 .86.156 1.172.469.312.312.469.703.469 1.172v25L27 27H8.64c-.468 0-.859-.156-1.171-.469C7.156 26.22 7 25.828 7 25.36V22h21.64V7H32z"}})])
          )
        }
      }
    